// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".m-dialog-goods-scanner__link[data-v-0761b1ad]{font-size:.75rem!important;margin:10px auto 30px;display:block}", ""]);
// Exports
module.exports = exports;
